<template>
  <b-card>
    <!-- Alert: No item found -->
    <b-tabs pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">{{ $t('Account') }}</span>
        </template>
        <tab-lead-information
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
     
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BAlert, BLink, BCard, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import TabLeadInformation from './TabLeadInformation.vue'

export default {
  components: {
    TabLeadInformation,
    ToastificationContent,
    vSelect,
    flatPickr,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  data() {
    return {
      iframe_src: '',
      paymentMethods:[],
      centerOptions: [],
      client_module:JSON.parse(localStorage.getItem('userData')),
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],

    }
  },
  created() {
    this.get_lead_data()
    this.get_center_data()
  },
  methods: {
    save_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.id}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },

    get_lead_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/lead/${router.currentRoute.params.id}/`)
        .then(res => {
          if (process.env.VUE_APP_VERSION != res.data.version) {
           // this.$router.go(0);
          }
          this.userData = res.data
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
